import { writable } from "svelte/store";

export function withPromiseResults<T>(fun) {
  let success = writable<T>(null);
  let failure = writable<Error>(null);
  return [
    function(...args) {
      success.set(null)
      failure.set(null)
      return fun.apply(this, args).then(
        v =>{
          success.set(v)
          return v
        },
        e => {
          failure.set(e)
          return e
        }
      )
    },
    {subscribe: success.subscribe},
    {subscribe: failure.subscribe}
  ] as const
}